import { FormikErrors } from 'formik';

const emptyObject = {};

export const validateRequired = <T>(values: T) => (prop: keyof T, message: string): FormikErrors<T> => {
  if (!values[prop]) {
    return { [prop]: message } as FormikErrors<T>;
  }
  return emptyObject;
};

export const validateEmail = <T>(values: T) => (prop: keyof T, message: string): FormikErrors<T> => {
  const v = values[prop] as unknown as string;
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(v)) {
    return { [prop]: message } as FormikErrors<T>;
  }
  return emptyObject;
};

export const validatePhone = <T>(values: T) => (prop: keyof T, pProp: keyof T, message: string): FormikErrors<T> => {
  const phone = values[prop] as unknown as string;
  const properLength = values[pProp] as unknown as number;
  if (phone && phone.length !== properLength) {
    return { [prop]: message } as FormikErrors<T>;
  }
  return emptyObject;
};

export const validateBirthday = <T>(values: T) => (prop: keyof T, message: string): FormikErrors<T> => {
  const birthday = values[prop] as unknown as string;
  if (birthday) {
    const has2 = birthday.split('-');
    const [year, month, day] = has2;
    const todayDate = new Date();
    const birthdayDate = new Date(birthday);

    if (birthday.length !== 10 ||
      has2.length !== 3 ||
      month.length !== 2 ||
      Number(month) > 12 ||
      day.length !== 2 ||
      Number(day) > 31 ||
      year.length !== 4 ||
      Number(year) < 1900 ||
      birthdayDate > todayDate) {
      return { [prop]: message } as FormikErrors<T>;
    }
  }
  return emptyObject;
};
